module.exports = __webpack_public_path__ + "static/media/Bar Chart.76b91c69.svg";